// @flow

import { observer } from "mobx-react";
import React from "react";

import AppearanceStore from "app/stores/AppearanceStore";
import GlobalSettingsStore from "app/stores/GlobalSettingsStore";
import UserStore from "app/stores/UserStore";
import VideoSearchStore from "app/stores/VideoSearchStore";

import Navbar from "app/components/Navbar/Navbar";

type Props = {
    container?: string
};

@observer
export default class NavbarContainer extends React.Component<Props> {
    render() {
        return (
            <Navbar
                user={UserStore.user}
                hideSearch={!UserStore.hasEarlyAccess}
                onUrl={VideoSearchStore.resolve}
                theme={AppearanceStore.theme}
                logoType={GlobalSettingsStore.logo}
                container={this.props.container}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/NavbarContainer.js